export const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
const aliases = {djuntor:'disjuntor',djuntores:'disjuntores',dijuntor:'disjuntor',disjutor:'disjuntor',dijuntores:'disjuntores'};
export const corrected = value => normalize(value).split(' ').map(w => aliases[w] || w).join(' ');
function distance(a,b) {
  let row = Array.from({length:b.length+1},(_,i)=>i);
  for (let i=1;i<=a.length;i++) {
    const next=[i];
    for(let j=1;j<=b.length;j++) next[j]=Math.min(next[j-1]+1,row[j]+1,row[j-1]+(a[i-1]===b[j-1]?0:1));
    row=next;
  }
  return row[b.length];
}
export function findProducts(products, value) {
  const q=corrected(value);
  if(!q) return [];
  const tokens=q.split(' ');
  return products.filter(p=>{
    const title=normalize(p.title);
    if(q.length===1) return title.startsWith(q);
    const words=normalize([p.title,p.vendor,p.type].join(' ')).split(' ');
    return tokens.every(t=>words.some(w=>w.startsWith(t) || (t.length>=4 && distance(t,w)<=(t.length>=7?2:1))));
  }).sort((a,b)=>a.title.localeCompare(b.title,'pt-BR',{sensitivity:'base',numeric:true}));
}
if(typeof document!=='undefined') {
  const config=document.querySelector('#dc-smart-search-config');
  if(config) init(JSON.parse(config.textContent));
}
function init(config) {
  let catalogPromise;
  const money=new Intl.NumberFormat('pt-BR',{style:'currency',currency:config.currency});
  const load=()=>catalogPromise || (catalogPromise=(async()=>{
    let products=[];
    for(let page=1,pages=1;page<=pages;page++){
      const url=new URL(config.catalogUrl,location.origin);
      url.searchParams.set('section_id','dc-search-index');url.searchParams.set('page',page);
      const response=await fetch(url,{credentials:'same-origin'});
      if(!response.ok) throw new Error('Catálogo indisponível');
      const html=new DOMParser().parseFromString(await response.text(),'text/html');
      const element=html.querySelector('#dc-search-catalog');
      if(!element) throw new Error('Índice indisponível');
      const data=JSON.parse(element.textContent);
      products.push(...data.products);pages=data.pages;
    }
    return products;
  })().catch(error=>{catalogPromise=null;throw error;}));
  const el=(tag,cls,text)=>{const e=document.createElement(tag);if(cls)e.className=cls;if(text)e.textContent=text;return e;};
  function card(p,compact){
    const a=el('a',compact?'dc-smart-item':'dc-smart-card');a.href=p.url;
    if(p.image){const img=el('img');img.src=p.image;img.alt='';img.width=compact?56:240;img.height=compact?56:240;img.loading='lazy';a.append(img);}
    const detail=el('span','dc-smart-detail');detail.append(el('span','dc-smart-title',p.title));
    detail.append(el('strong','dc-smart-price',p.price>0?money.format(p.price/100):'Sem preço'));
    if(!p.available) detail.append(el('span','dc-smart-stock','Indisponível'));
    a.append(detail);return a;
  }
  const input=document.querySelector('#dc-search-input');
  if(input){
    const form=input.form;
    const panel=el('div','dc-smart-panel');panel.id='dc-smart-suggestions';panel.hidden=true;
    const status=el('p','dc-smart-status');status.setAttribute('role','status');status.setAttribute('aria-live','polite');
    const list=el('ul','dc-smart-list');panel.append(status,list);form.append(panel);
    input.setAttribute('autocomplete','off');input.setAttribute('aria-controls',panel.id);input.setAttribute('aria-expanded','false');
    input.setAttribute('aria-label','Pesquisar produtos por nome, marca ou letra inicial');
    let revision=0,timer,active=-1;
    const close=()=>{panel.hidden=true;input.setAttribute('aria-expanded','false');active=-1;};
    const show=()=>{panel.hidden=false;input.setAttribute('aria-expanded','true');};
    async function update(){
      const current=++revision;const term=input.value.trim();active=-1;
      if(!term){close();return;}
      show();status.textContent='Buscando produtos…';list.replaceChildren();
      try{
        const matches=findProducts(await load(),term);
        if(current!==revision || input.value.trim()!==term) return;
        status.textContent=matches.length ? matches.length+' produto(s) • A a Z' : 'Nenhum produto publicado encontrado. Tente outro nome ou marca.';
        if(corrected(term)!==normalize(term)) status.textContent+=' • Busca por '+corrected(term);
        const frag=document.createDocumentFragment();
        for(const p of matches){const li=el('li');li.append(card(p,true));frag.append(li);}
        list.replaceChildren(frag);
      }catch(error){if(current===revision) status.textContent='Não foi possível carregar as sugestões. Use Buscar para tentar a pesquisa.';}
    }
    input.addEventListener('focus',()=>{load().catch(()=>{});if(input.value.trim())update();});
    input.addEventListener('input',()=>{revision++;clearTimeout(timer);timer=setTimeout(update,150);});
    input.addEventListener('keydown',event=>{
      if(event.key==='Escape'){revision++;clearTimeout(timer);close();}
      if(event.key==='ArrowDown'&&!panel.hidden){const links=list.querySelectorAll('a');if(links.length){event.preventDefault();links[0].focus();}}
    });
    panel.addEventListener('keydown',event=>{
      const links=Array.from(list.querySelectorAll('a'));active=links.indexOf(document.activeElement);
      if(event.key==='Escape'){close();input.focus();return;}
      if(event.key==='ArrowDown'||event.key==='ArrowUp'){
        event.preventDefault();const next=active+(event.key==='ArrowDown'?1:-1);
        if(next<0)input.focus();else links[Math.min(next,links.length-1)]?.focus();
      }
    });
    document.addEventListener('click',event=>{if(!form.contains(event.target)){revision++;clearTimeout(timer);close();}});
    form.addEventListener('focusout',()=>setTimeout(()=>{if(!form.contains(document.activeElement)){revision++;clearTimeout(timer);close();}},0));
  }
  // Keep ordinary Shopify search as the no-JavaScript/network-failure fallback.
  document.addEventListener('submit',event=>{
    const form=event.target;
    if(!(form instanceof HTMLFormElement))return;
    const field=form.querySelector('input[name="q"]');
    if(field && new URL(form.action,location.origin).pathname===new URL(config.searchUrl,location.origin).pathname){
      const term=corrected(field.value);if(term)field.value=term;
    }
  },true);
  const term=new URL(location.href).searchParams.get('q')||'';
  if(config.isSearch && term.trim()){
    load().then(products=>{
      const main=document.querySelector('#MainContent');if(!main)return;
      const section=el('section','dc-smart-results');section.setAttribute('aria-label','Resultados da pesquisa');
      section.append(el('h1','', 'Resultados para “'+term+'”'));
      const matches=findProducts(products,term);
      document.title='Pesquisa: '+matches.length+' resultados para “'+term+'” — Depósito da Construção';
      section.append(el('p','dc-smart-status',matches.length+' produto(s) encontrado(s) • Ordem alfabética de A a Z'));
      if(corrected(term)!==normalize(term))section.append(el('p','','Pesquisando por: '+corrected(term)));
      const grid=el('div','dc-smart-grid');let shown=0;
      const more=el('button','dc-smart-more','Mostrar mais produtos');more.type='button';
      const add=()=>{const frag=document.createDocumentFragment();for(const p of matches.slice(shown,shown+48))frag.append(card(p,false));grid.append(frag);shown+=48;more.hidden=shown>=matches.length;};
      more.addEventListener('click',add);add();
      if(!matches.length)section.append(el('p','','Não encontramos produtos publicados. Tente outra palavra ou escolha um departamento.'));
      section.append(grid,more);
      // Hide original results only after the complete catalog has loaded successfully.
      for(const child of main.children)child.hidden=true;
      main.prepend(section);
    }).catch(()=>{});
  }
}
